import React from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconPicker = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M14.908.732a2.5 2.5 0 010 3.536L13.14 6.035l1.415 1.415-2.122 2.121-.975-.975-5.56 5.56-.422-.421.164.611-3.707.993-.001.009-.015-.005-1.106.297L.638 15 0 14.83l.296-1.106-.003-.015.008-.003L1.294 10l.61.163-.42-.42 5.56-5.561-.975-.975 2.122-2.121L9.605 2.5 11.373.732a2.5 2.5 0 013.535 0zm-6.45 4.864l-5.347 5.346-.58 2.166 2.166-.58 5.347-5.346-1.586-1.586z"
          id="picker_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="picker_svg__b" fill="#fff">
          <use xlinkHref="#picker_svg__a" />
        </mask>
        <use fill="#D8D8D8" xlinkHref="#picker_svg__a" />
        <path fill={color} mask="url(#picker_svg__b)" d="M-5.5-7h28v28h-28z" />
      </g>
    </>
  ),
})``;

export default IconPicker;
